import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { Course } from '@/domain/entities/problem/course'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { CourseStatisticsModuleName } from '@/store/modules/modules'

export class CourseStatisticsViewModel {
  private store = useStore()

  courseStatisticsList: ComputedRef<{ [programLanguage: string]: Course }> = computed(
    () => this.store.getters[`${CourseStatisticsModuleName}/courseStatisticsList`]
  )

  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${CourseStatisticsModuleName}/isLoading`])

  error: ComputedRef<string | null> = computed(() => this.store.getters[`${CourseStatisticsModuleName}/error`])

  async getCourseStatisticsListByLanguage(
    courseName: string,
    userId: string,
    programLanguage: ProgramLanguageType
  ): Promise<Course | undefined> {
    return await this.store.dispatch(`${CourseStatisticsModuleName}/getCourseStatisticsListByLanguage`, {
      courseName,
      userId,
      programLanguage
    })
  }

  clearCourseStatisticsList(): void {
    this.store.commit(`${CourseStatisticsModuleName}/clearCourseStatisticsList`)
  }
}
